import { Map, MapMouseEvent, ViewState } from "react-map-gl/mapbox";
import { INITIAL_VIEW_STATE } from "@/constants/map.const";
import { useMemo } from "react";
import { MAPBOX_ACCESS_TOKEN } from "@/constants/mapbox.const";
import { CustomMapProps } from "./types/custom-map-props.type";
import { LngLatBounds } from "mapbox-gl";

export const CustomMap = ({
  initialBounds,
  onViewPortChange,
  children,
  mapRef,
  mapStyle,
  onMapClick,
  initialView = INITIAL_VIEW_STATE,
  reuseMaps,
}: CustomMapProps) => {
  const handleMoveEnd = (input: ViewState) => {
    onViewPortChange(input);
  };

  const handleZoomEnd = (input: ViewState) => {
    onViewPortChange(input);
  };

  const initialViewState: ViewState = useMemo(() => {
    if (initialBounds) {
      try {
        const bounds = LngLatBounds.convert(initialBounds);
        const longitude = (bounds.getWest() + bounds.getEast()) / 2;
        const latitude = (bounds.getSouth() + bounds.getNorth()) / 2;
        return { longitude, latitude, zoom: 10 } as ViewState;
      } catch {
        return initialView;
      }
    }
    return initialView;
  }, [initialBounds, initialView]);

  const moveMapToCity = () => {
    if (initialBounds) {
      mapRef?.current?.fitBounds(initialBounds, { padding: 30 });
    } else {
      mapRef?.current?.flyTo({
        center: [initialViewState.longitude, initialViewState.latitude],
        zoom: initialViewState.zoom,
      });
    }
  };

  const handleOnClick = (e: MapMouseEvent) => {
    e.preventDefault();
    const { lng, lat } = e.lngLat;
    onMapClick?.({ longitude: lng, latitude: lat });
  };
  return (
    <Map
      reuseMaps={reuseMaps}
      key={mapStyle} // Add this key prop to force the map to re-render when the mapStyle changes
      ref={mapRef}
      initialViewState={initialViewState}
      onMoveEnd={(e) => handleMoveEnd(e.viewState)}
      mapboxAccessToken={MAPBOX_ACCESS_TOKEN}
      mapStyle={mapStyle}
      onZoomEnd={(e) => handleZoomEnd(e.viewState)}
      onLoad={moveMapToCity}
      attributionControl={false}
      onClick={handleOnClick}
    >
      {children}
    </Map>
  );
};
